module.exports = __webpack_public_path__ + "media/images/dominique-49e699a6.png";